export default __webpack_public_path__ + "static/media/partnership-moon.5c78a7de.jpg";